import * as React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { DayPicker } from 'react-day-picker'

import { cn } from './cn'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3 bg-white', className)}
      classNames={{
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
        month: 'space-y-4',
        caption: 'flex justify-center pt-1 relative items-center',
        caption_label:
          'text-sm font-semibold tracking-[-0.2px] text-neutral-800',
        nav: 'space-x-1 flex items-center',
        nav_button: cn(
          'inline-flex items-center justify-center rounded-full text-sm font-medium transition-colors text-neutral-700 hover:bg-neutral-100 disabled:pointer-events-none disabled:opacity-50',
          'h-8 w-8 bg-transparent p-0'
        ),
        nav_button_previous: 'absolute left-1',
        nav_button_next: 'absolute right-1',
        table: 'w-full border-collapse',
        head_row: 'flex',
        head_cell:
          'text-neutral-500 w-9 font-medium text-xs uppercase tracking-[-0.2px]',
        row: 'flex w-full mt-1',
        cell: 'h-9 w-9 text-center text-sm p-0 relative focus-within:relative focus-within:z-20',
        day: cn(
          'inline-flex items-center justify-center rounded-full text-sm transition-colors',
          'h-9 w-9 p-0 font-medium tracking-[-0.2px] text-neutral-800',
          'hover:bg-neutral-100',
          'aria-selected:opacity-100 disabled:pointer-events-none disabled:opacity-50'
        ),
        day_range_end: 'day-range-end',
        day_selected:
          '!bg-brand-active !text-white hover:!bg-brand-active focus:!bg-brand-active',
        day_today: 'bg-neutral-100 text-neutral-800',
        day_outside:
          'day-outside text-neutral-400 aria-selected:text-neutral-400',
        day_disabled: 'text-neutral-300 opacity-50',
        day_range_middle:
          'aria-selected:bg-neutral-100 aria-selected:text-neutral-800',
        day_hidden: 'invisible',
        ...classNames,
      }}
      components={{
        IconLeft: () => <ChevronLeft className="h-4 w-4" />,
        IconRight: () => <ChevronRight className="h-4 w-4" />,
      }}
      {...props}
    />
  )
}
Calendar.displayName = 'Calendar'

export { Calendar }
